export default __webpack_public_path__ + "static/media/Blue-Android-6.90222268.png";